import { Skeleton } from 'ui/skeleton';
import { Item, Metadata, Thumbnail, Title } from './ActivityItem.styled';
import { PreviewThumbnailLoading } from 'modules/missionControl/lib/components/PreviewThumbnail/PreviewThumbnailLoading';
import { MAX_ITEM_TITLE_WIDTH } from './ActivityItem.constants';

export const ActivityItemLoading = () => {
  return (
    <Item>
      <Thumbnail>
        <PreviewThumbnailLoading />
      </Thumbnail>
      <Title>
        <Skeleton width={MAX_ITEM_TITLE_WIDTH} height={20} isRound />
      </Title>
      <Metadata>
        <Skeleton width={MAX_ITEM_TITLE_WIDTH} height={20} isRound />
      </Metadata>
    </Item>
  );
};
